/**
 * Validates the provided template name.
 *
 * This function checks if the template name is not empty after trimming whitespace.
 * If the name is empty, an error message is returned. Otherwise, it returns null indicating no error.
 *
 * @function
 * @param {string} name - The template name to validate
 * @returns {string | null} Error message if validation fails, or null if validation passes
 */
export const validateTemplateName = (name: string): string | null => {
  if (!name.trim()) {
    return 'Field cannot be empty';
  }
  return null;
};
